<template>
  <div class="player-container">
    <el-row>
      <el-button type="primary" @click="handleAdd">添加补录赛事</el-button>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        label="排序(倒序)"
        width="80"
        prop="seq">
      </el-table-column>
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>联赛名称</div>
          <el-input
            v-model="search.name"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatType"
        width="120"
        prop="type">
        <template slot="header" slot-scope="scope">
          <div>比赛类型</div>
          <el-select v-model="search.type" @change="quickSearch" placeholder="请选择" clearable>
            <el-option
              v-for="(item, i) in typeStrs"
              :key="i"
              :label="item"
              :value="i"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatLevel"
        width="120"
        prop="level">
        <template slot="header" slot-scope="scope">
          <div>级别</div>
          <el-select v-model="search.level" @change="quickSearch" placeholder="请选择" clearable>
            <el-option
              v-for="(item, i) in levelStrs"
              :key="i"
              :label="item"
              :value="i"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        :formatter="formatDate"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatAudit"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>状态</div>
          <el-select v-model="search.status" @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="350"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            @click="goGameList(scope.row.id)">赛程管理</el-button>
          <el-button
            size="mini"
            @click="goReferees(scope.row.id)">裁判统计</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form :model="dialogForm" :rules="rules" ref="dialogForm" class="modal" label-width="100px">
        <el-form-item label="联赛名称">
          <el-input v-model="dialogForm.name" />
        </el-form-item>
        <el-form-item label="排序(倒序)" >
          <el-input
            v-model="dialogForm.seq"
            type="Number"
            placeholder="请输入排序"/>
        </el-form-item>
        <el-form-item label="联赛类型">
          <el-select v-model="dialogForm.gameType" placeholder="请选择">
            <el-option label="正常" value="正常"/>
            <el-option label="3v3" value="3v3"/>
            <el-option label="4v4" value="4v4"/>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛类型">
          <el-select v-model="dialogForm.type" placeholder="请选择">
            <el-option label="标准比赛" :value="0"/>
            <el-option label="小场地" :value="1"/>
          </el-select>
        </el-form-item>
        <el-form-item label="级别">
          <el-select v-model="dialogForm.level" placeholder="请选择">
            <el-option label="国际" :value="0"/>
            <el-option label="国家" :value="1"/>
            <el-option label="市级" :value="2"/>
            <el-option label="区级" :value="3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛场次数">
          <el-input v-model="dialogForm.gameCount" type="number" />
        </el-form-item>
        <el-form-item
          label="起止日期">
          <el-date-picker
            v-model="dialogForm.beginDate"
            type="date"
            placeholder="选择开始日期">
          </el-date-picker>
          <span>至</span>
          <el-date-picker
            v-model="dialogForm.endDate"
            type="date"
            placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" >
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->

  </div>
</template>

<script>

import * as moment from 'moment'
import find from 'lodash/find'
import { getPlayerById } from '@/api/player'
import { adminCreateOldMatch, adminGetMatchList, updateMatchInfo, deleteMatch, matchStateList } from '@/api/match'

const defaultForm = {
  gameType: '正常',
  status: 0
}

export default {
  name: 'PlayerList',
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: false,
      roleList: [],
      isEditMode: false,
      modalTitle: '',
      dialogForm: {},
      dialogVisible: false,
      formLabelWidth: '100px',
      stateList: [],
      imageUrl: '',
      rules: {},
      dialogFormVisible: false,
      typeStrs:["标准比赛", "小场地"],
      levelStrs:["国际", "国家", "市级", "区级"]
    }
  },
  created() {
    this.getList()
    this.getStateList()
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加补录赛事'
      this.dialogForm = defaultForm
    },
    handleEdit(index, row) {
      this.dialogForm = Object.assign(defaultForm, this.list[index])
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑补录赛事'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该补录赛事, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteMatch(this.list[index].id)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updateMatch()
          } else {
            this.addMatch()
          }
        } else {
          return false
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        out: 2
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      adminGetMatchList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    formatType: function(row, column) {
      return this.typeStrs[row[column.property]]
    },
    formatLevel: function(row, column) {
      return this.levelStrs[row[column.property]]
    },
    addMatch() {
      adminCreateOldMatch(this.dialogForm).then(response => {
        const data = response.data
        if (data && data.match) {
          this.dialogVisible = false
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    updateMatch() {
      const data = {
        id: this.dialogForm.id,
        seq: this.dialogForm.seq,
        name: this.dialogForm.name,
        type: this.dialogForm.type,
        level: this.dialogForm.level,
        beginDate: this.dialogForm.beginDate,
        endDate: this.dialogForm.endDate,
        gameType: this.dialogForm.gameType,
        status: this.dialogForm.status,
        gameCount: this.dialogForm.gameCount,
      }
      updateMatchInfo(data).then(response => {
        const data = response.data
        if (data) {
          this.dialogVisible = false
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    deleteMatch(id) {
      const params = {
        id: id,
        status: -2
      }
      deleteMatch(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getStateList() {
      this.stateList = matchStateList
    },
    goReferees(id) {
      this.$router.push({
        name: 'OldLeagueRefereeList',
        params: {
          id: id
        }
      })
    },
    goGameList(id) {
      this.$router.push({
        name: 'OldLeagueGameList',
        params: {
          id: id
        }
      })
    },
    formatAudit: function(row, column) {
      const value = row[column.property]
      const obj = find(this.stateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

  }
</style>
